import { Button, DialogContent, Typography } from '@mui/material';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import { useTranslation } from 'react-i18next';

import styles from './WelcomeDialog.module.scss';

export interface WelcomeDialogProps extends DialogProps {
  onConfirm: () => void;
}

export function WelcomeDialog({ onConfirm, ...rest }: WelcomeDialogProps) {
  const { t } = useTranslation('providerRoom');

  return (
    <Dialog {...rest} className={styles.dialog}>
      <DialogContent>
        <Typography component='h4' variant='h4'>
          {t('welcomeDialogFantastic')} {'\u{1F389}'}
        </Typography>

        <Typography component='p' variant='body2'>
          {t('welcomeDialogWaitingRoomNow')} <strong>{t('welcomeDialogLive')}</strong>!
        </Typography>

        <Typography component='p' variant='body2'>
          <strong>{t('welcomeDialogInviteGuest')}</strong> {t('and')}{' '}
          <strong>{t('welcomeDialogStartFirstSession')}</strong> {t('now')}!
        </Typography>

        <Button variant='contained' onClick={onConfirm} className={styles.formButton}>
          {t('getStarted')}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
